// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3f8tB","checkboxCol":"Table_checkboxCol__3vH5T","emailCol":"Table_emailCol__1eXTe","actionCol":"Table_actionCol__37Y64"};